import FeatureIntro from "../../../components/FeatureIntro";
import ColorSwatchesIcon from "../../../components/icons/ColorSwatchesIcon";
import QrCodeIcon from "../../../components/icons/QrCodeIcon";
import UserSyncOnlineIcon from "../../../components/icons/UserSyncOnlineIcon";

interface IntroOverlayProps {
  onContinue: () => void;
}

const IntroOverlay = ({ onContinue }: IntroOverlayProps) => {
  const features = [
    {
      icon: (
        <QrCodeIcon className="w-6 h-6" strokeWidth={1.5} color="#4147D5" />
      ),
      title: "Generate cards with unique QR codes for each guest",
    },
    {
      icon: (
        <ColorSwatchesIcon
          strokeColor="#4147D5"
          strokeWidth={1.3}
          className="w-6 h-6"
        />
      ),
      title: "Use system template or upload your own design",
    },
    {
      icon: (
        <UserSyncOnlineIcon
          strokeColor="#4147D5"
          strokeWidth={1.5}
          className="w-6 h-6"
        />
      ),
      title: "Use weddn check-in app for guests accreditation on d-day",
    },
  ];

  return (
    <div className="flex items-center justify-center h-[calc(100vh-72px)] px-4">
      <div className="max-w-xs w-full">
        <FeatureIntro
          title="ACCESS CARD"
          subtitle="Limit access to your wedding with QR-code access cards"
          features={features}
          buttonText="CONTINUE"
          onButtonClick={onContinue}
        />
      </div>
    </div>
  );
};

export default IntroOverlay;
